import type { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { Gazetteer } from '@bridebook/toolbox/src/gazetteer';

export interface ISupplierLoggedOutAnalyticsProps {
  supplierId: ISupplier['id'];
  supplierName: ISupplier['name'];
  supplierCategory: ISupplier['type'][0];
  supplierCountryCode: ISupplier['address']['country'];
  supplierCountryName?: string;
  supplierTier?: number;
}

export const getSupplierGenericProperties = ({
  supplier,
  supplierTier,
}: {
  supplier: ISupplier | null;
  supplierTier?: number;
}): ISupplierLoggedOutAnalyticsProps | null => {
  if (!supplier) return null;

  return {
    supplierId: supplier.id,
    supplierName: supplier.name,
    supplierCategory: supplier.type[0],
    supplierCountryCode: supplier.address.country,
    supplierCountryName: supplier?.l10n.country
      ? Gazetteer.getCountryName(supplier?.l10n.country)
      : undefined,
    ...(supplierTier && { supplierTier }),
  };
};
